import { Reveal } from "@/components/Reveal";

const NEON_IMG = "/assets/baianeira/mais-amor-neon.jpeg";

const buildConditions = (discount, validityDays) => {
  const validity =
    validityDays === 14 ? "due settimane" : `${validityDays} giorni`;
  return [
    `Lo sconto del ${discount}% si applica esclusivamente alle pietanze ordinate dal menù alla carta.`,
    "Bevande, dolci e coperto sono esclusi dallo sconto.",
    "Il coupon non è valido su aperisushi e menù degustazione.",
    "Il coupon è utilizzabile esclusivamente presso Baianeira Sushi Fusion, Roma.",
    "Il coupon deve essere presentato al personale prima della richiesta del conto.",
    "Il cliente deve comunicare di avere il coupon al momento della prenotazione o del proprio arrivo al ristorante.",
    "Il coupon è utilizzabile una sola volta.",
    `Il coupon è utilizzabile entro ${validity} dall'emissione.`,
    "La promozione non è cumulabile con altre offerte o sconti.",
    "Il coupon non è convertibile in denaro.",
  ];
};

export const Conditions = ({ extra = [], discount = 20, validityDays = 14 }) => {
  const conditions = buildConditions(discount, validityDays);

  return (
    <section
      id="condizioni"
      data-testid="conditions-section"
      className="relative border-t border-[#D4AF37]/15 bg-[#050505] py-20 md:py-28"
    >
      <div className="mx-auto max-w-6xl px-5 md:px-8">
        <div className="grid gap-12 md:grid-cols-[1.2fr,0.8fr] md:gap-16">
          <div>
            <Reveal>
              <p className="text-[10px] font-semibold tracking-[0.4em] text-[#D4AF37] md:text-xs">
                REGOLAMENTO DELLA PROMOZIONE
              </p>
              <h2 className="mt-4 font-display text-3xl text-[#F5F2E9] md:text-5xl">
                Condizioni di utilizzo
              </h2>
            </Reveal>

            <ol data-testid="conditions-list" className="mt-10 md:mt-14">
              {conditions.map((c, i) => (
                <Reveal key={i} delay={i * 0.05}>
                  <li className="flex gap-5 border-t border-[#D4AF37]/15 py-5 last:border-b">
                    <span className="font-display text-lg text-[#D4AF37]/70">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <p className="text-sm leading-relaxed text-[#E0E0E0] md:text-base">{c}</p>
                  </li>
                </Reveal>
              ))}
            </ol>

            {extra.length > 0 && (
              <Reveal delay={0.1}>
                <div className="mt-8 border border-[#D4AF37]/30 p-6">
                  <p className="text-[10px] font-semibold tracking-[0.3em] text-[#D4AF37]">
                    CONDIZIONI AGGIUNTIVE
                  </p>
                  <ul className="mt-4 space-y-2">
                    {extra.map((e, i) => (
                      <li key={i} className="text-sm leading-relaxed text-[#E0E0E0]">
                        · {e}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            )}
          </div>

          <Reveal delay={0.2}>
            <div className="relative mx-auto max-w-xs pb-8 pr-8 md:sticky md:top-28 md:max-w-sm md:pb-12 md:pr-12">
              <div className="absolute -left-3 -top-3 hidden h-full w-full border border-[#D4AF37]/40 md:block" />
              <img
                src={NEON_IMG}
                alt="Mais amor por favor"
                className="relative aspect-[4/5] w-full object-cover"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Conditions;
